import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { useRecoilState } from 'recoil';

import HouseIcon from '@/assets/vectors/menu/house.svg';
import { menuSelector } from '@/components/state/MenuState';
import { useActiveLink } from '@/hooks/useActiveLink/useActiveLink';

import { ItemLabel, ToolItem } from '../MenuItems.styles';

const OpportunitiesItem = () => {
  const { t } = useTranslation();

  const [isOpen, updateMenu] = useRecoilState(menuSelector);
  const isActive = useActiveLink('/map-properties');

  return (
    <Link
      href="/map-properties"
      id="sidebar-menu_opportunities"
      onMouseEnter={() => {
        if (!isOpen) {
          updateMenu(true);
        }
      }}
    >
      <ToolItem isActive={isActive} isOpen={isOpen}>
        <HouseIcon />
        <ItemLabel>{t('ourListings')}</ItemLabel>
      </ToolItem>
    </Link>
  );
};

export default OpportunitiesItem;
